import { Listbox } from '@headlessui/react';

import type {
    SelectComponentProps,
    OptionType
} from '@/components/base/Select/SelectComponent/types';
import Tooltip from '@/components/base/Tooltip';
import Icon from '@/components/base/Icon';

type SelectLabelProps<TOption, TSelected> = Readonly<
    Pick<SelectComponentProps<TOption, TSelected>, 'label' | 'required' | 'tooltipContent'>
>;
export function SelectLabel<TOption extends OptionType, TSelected extends TOption | TOption[]>({
    label,
    required,
    tooltipContent
}: SelectLabelProps<TOption, TSelected>) {
    if (!label) {
        return null;
    }

    return (
        <Listbox.Label className="mb-2 flex items-center text-xs text-icoGray-500 dark:text-icoDarkMode-wolf">
            {label}
            {required ? <span className="text-icoBlue">*</span> : null}
            {tooltipContent ? (
                <Tooltip content={tooltipContent}>
                    <Icon icon="help" className="ml-0.5" />
                </Tooltip>
            ) : null}
        </Listbox.Label>
    );
}
